KMVP.merchantbackoffice = {

    myFormatFunction: function(limit, numberOfPages, currentPage) {
        var halfLimit = Math.floor(limit / 2);
        var beginPage = 0;
        var endPage = 0;

        if (limit > numberOfPages || currentPage + halfLimit < limit) {
            beginPage = 1;
        } else {
            if (currentPage + halfLimit < numberOfPages) {
                beginPage = currentPage + 1 - halfLimit;
            } else {
                beginPage = numberOfPages + 1 - limit;
            }
        }

        if (limit > numberOfPages || !(currentPage + 1 < numberOfPages)) {
            endPage = numberOfPages;
        } else {
            endPage = beginPage + limit - 1;
        }

        return KMVP.searchandpagination.getVisiblePagesArray(beginPage, endPage, currentPage);
    },


    /**
     * Refreshes merchant products.
     *
     * @param $form (optional) contains parameters for special product to refresh
     * @param callback (optional) callback if completed
     */
    loadMerchantProducts: function ($form, callback) {
        var $products = $('.js-merchant-backoffice-products'),
            $syncButton = $('.js-merchant-backoffice-product-sync-btn'),
            $spinnerObject = $('.js-merchant-backoffice-spinner'),
            url = $('#js-merchant-backoffice-products-template').data('url');
        // only execute ajax if you are at the merchant backoffice
        if (url) {
            $.ajax({
                dataType: "json",
                url: $form && $form.length ? url + '?' + $form.serialize() : url,
                beforeSend: function () {
                    $spinnerObject.showSpinner();
                },
                success: function (data) {
                    $syncButton.prop('disabled', data.fullySynchronized);

                    // calling jsrender template
                    var paginationHelper = {paginationHelper: KMVP.merchantbackoffice.myFormatFunction};
                    $products.html($.templates({
                        markup: '#js-merchant-backoffice-products-template',
                        helpers: paginationHelper
                    }).render(data));

                    $products.find('.js-load-product-details').click(function () {
                        KMVP.merchantbackoffice.loadMerchantProductDetails($(this).attr('data-code'));
                    });

                    KMVP.searchandpagination.updateUiFromFormAndBindLinks(data.searchPageData);
                },
                complete: function () {
                    $spinnerObject.hideSpinner();
                    if (callback) {
                        callback();
                    }
                }
            });
        }
    },

    /**
     * Refreshes product details for product
     *
     * @param code product code
     */
    loadMerchantProductDetails: function (code) {
        var $productDetailsRow = $('.js-product-details-' + code);
        if ($productDetailsRow.length) {
            $productDetailsRow.slideToggle();
        } else {
            var url = $('#js-merchant-backoffice-product-details-template').data('url') + '/' + code;
            $.ajax({
                dataType: "json",
                url: url,
                success: KMVP.merchantbackoffice.showProductDetails
            });
        }
    },

    /**
     * Binds click event for sync of products
     */
    bindSynchronizeButton: function () {
        var $syncButton = $('.js-merchant-backoffice-product-sync-btn');

        $syncButton.click(function () {
            $syncButton.prop('disabled', true);

            var $button = $(this),
                url = $button.data('url');

            $.ajax({
                url: url,
                data: $('.js-merchant-backoffice-products-filter-form').serializeObject(),
                type: 'post',
                beforeSend: function () {
                    $syncButton.showSpinner();
                },
                success: function () {
                    KMVP.merchantbackoffice.loadMerchantProducts(null, function () {
                        $syncButton.hideSpinner();
                        $(".merchant-backoffice-syncmessage .success").show();
                        $(".merchant-backoffice-syncmessage .error").hide();

                        KMVP.merchantbackoffice.resetFilterForm();
                    });
                },
                global: false,
                error: function () {
                    $(".merchant-backoffice-syncmessage .success").hide();
                    $(".merchant-backoffice-syncmessage .error").show();
                },
                complete: function() {
                    $syncButton.prop('disabled', false);
                    $syncButton.hideSpinner();
                }
            });
        });
    },

    /**
     * Displays or replaces details for a product
     *
     * @param data
     */
    showProductDetails: function (data) {
        if (!data.fullySynchronized) {
            $('.js-merchant-backoffice-product-sync-btn').prop('disabled', false);
        }
        $.views.settings.allowCode(true);
        var oldProductDetailsRow = $('.js-product-details-' + data.code);
        var newProductDetailsRowContent = $.templates('#js-merchant-backoffice-product-details-template').render(data);
        var newProductDetailsRow = $();

        if (oldProductDetailsRow.length) {
            oldProductDetailsRow.replaceWith(newProductDetailsRowContent)
            newProductDetailsRow = $('.js-product-details-' + data.code);
            newProductDetailsRow.show();
        } else {
            var productOverviewRow = $('.js-product-overview-' + data.code);
            productOverviewRow.after(newProductDetailsRowContent);
            newProductDetailsRow = $('.js-product-details-' + data.code);
            newProductDetailsRow.slideDown();
        }
        KMVP.merchantbackoffice.bindProductForm(newProductDetailsRow);
    },

    /**
     *  Binds the filter submit event
     */
    bindProductFilterForm: function () {
        var productsFilterForm = $('.js-merchant-backoffice-products-filter-form');
        productsFilterForm.on("change", ":input", function (event) {
            $('.js-merchant-backoffice-product-sync-btn').prop('disabled', true);
        });

        productsFilterForm.on("submit", function (event) {
            event.preventDefault();
            KMVP.merchantbackoffice.loadMerchantProducts($(this));
        });

        productsFilterForm.find(".reset-link").on("click", function () {
            KMVP.merchantbackoffice.resetFilterForm();
        });
    },

    resetFilterForm: function () {
        $('.js-merchant-backoffice-products-filter-form :input').val("");
        // Reset the select elements back to the first option and refresh the jQuery Selectmenu widget to render the change
        $('.js-merchant-backoffice-products-filter-form select').each(function() {
            $(this).prop('selectedIndex', 0);
            $(this).iconselectmenu('refresh');
        });
    },

    /**
     * Bind single form for product preview url generation
     *
     * @param $productDetailsRow table row object
     */
    bindProductForm: function ($productDetailsRow) {
        var $form = $productDetailsRow.find('.js-merchant-backoffice-preview-form'),
            $validitySwitch = $form.find(".js-validity-switch"),
            $storeSelect = $form.find(".store-select"),
            $storeSelectOptions = $storeSelect.find("option");

        $validitySwitch.switchButton({
            off_label: $validitySwitch.data("active"),
            on_label: $validitySwitch.data("inactive"),
            height: 20,
            width: 40,
            button_width: 20,
            clear: false,
            clear_after: null
        });

        KMVP.merchantbackoffice.bindValiditySwitch($form, $storeSelect, $validitySwitch);

        $storeSelect.prop("readonly", $storeSelectOptions.length == 1);
        var $baseStoreFilter = $("#available\\.in\\.baseStore");
        if ($baseStoreFilter.val() != null) {
            $storeSelect.prop("readonly", true);
            $storeSelect.val($baseStoreFilter.val());
        }

        $form.ajaxForm({
            success: function (previewUrl) {
                var win = window.open(previewUrl, '_blank');
                win.focus();
            }
        });
        KMVP.merchantbackoffice.bindBaseStoreInputChange($productDetailsRow);
    },

    bindValiditySwitch: function($form, $storeSelect, $validitySwitch) {
        $validitySwitch.on("change", function () {
            var approval = $validitySwitch.prop("checked");
            KMVP.merchantbackoffice.approveProduct($form, $validitySwitch, $form[0].elements["productCode"].value, $storeSelect.val(), approval);
        });
    },

    approveProduct: function ($form, $validitySwitch, product, store, approval) {
        var $spinner = $validitySwitch.siblings(".js-validity-switch-spinner").find(".kmvp-spinner");
        $spinner.css("visibility", "visible");

        $.ajax({
            url: $validitySwitch.data("url"),
            type: "POST",
            data: {
                productCode: product,
                store: store,
                approved: approval
            },
            dataType: "json",
            success: function () {
                var $syncStatusIcon = $($(".js-product-overview-" + product + " .fa")[1]);
                $syncStatusIcon.removeClass("fa-check-circle");
                $syncStatusIcon.addClass("fa-minus-circle");
                $form.find(".store-select option[value='" + store + "']").data("approved", approval);
            },
            complete: function () {
                $(".js-merchant-backoffice-product-sync-btn").prop("disabled", false);
                $spinner.css("visibility", "hidden");
            }
        });
    },

    /**
     * Bind change on input for stores.
     *
     * @param $productDetailsRow table row object
     */
    bindBaseStoreInputChange: function ($productDetailsRow) {
        var $form = $productDetailsRow.find('.js-merchant-backoffice-preview-form'),
            $validitySwitch = $form.find(".js-validity-switch"),
            $storeSelect = $form.find(".store-select");

        var updateValiditySwitchStatus = function () {
            var approved = $storeSelect.find("option[value='" + $storeSelect.val() + "']").data("approved"),
                buttonState = $validitySwitch.prop("checked");
            if (approved != buttonState) {
                $validitySwitch.off("change");
                $validitySwitch.parent().find(".switch-button-button").click();
                KMVP.merchantbackoffice.bindValiditySwitch($form, $storeSelect, $validitySwitch);
            }
        };

        updateValiditySwitchStatus();
        $storeSelect.on("change", updateValiditySwitchStatus);
    },

    /**
     * Binds the product validation button. A colorbox with detailed information is displayed.
     */
    bindMerchantValidateProductsButton: function () {
        var $validateButton = $('.js-merchant-backoffice-product-validate-btn');

        $validateButton.click(function () {
            $.ajax({
                url: $(this).data('url'),
                data: $('.js-merchant-backoffice-products-filter-form').serializeObject(),
                type: 'get',
                beforeSend: function () {
                    $validateButton.prop('disabled', true);
                    $validateButton.showSpinner();
                },
                success: function (data) {
                    $.colorbox({
                        innerWidth: '600px',
                        innerHeight: '500px',
                        html: data,
                        scrolling: true,
                        onCleanup: function () {
                            $validateButton.hideSpinner();
                            $validateButton.prop('disabled', false);
                        },
                        onComplete: function () {
                            $(".js-merchant-backoffice-product-validation-close").on("click", function () {
                                $.colorbox.close();
                            });
                        }
                    });
                },
                error: function () {
                    $validateButton.hideSpinner();
                    $validateButton.prop('disabled', false);
                }
            });
        });
    },

    bindPaginationLink: function () {
        if ($("#merchant_back_office_order_page_search_form").length > 0) {
            $('.pagination a').on('click', function (e) {
                e.preventDefault();

                var href = $(this).attr("href");

                var page = href.substring(href.lastIndexOf('=') + 1);
                var form = $("#merchant_back_office_order_page_search_form");

                form.find('input[name="page"]').val(page);
                form.submit();
            });
        }
    }


};

$(document).ready(function () {
    KMVP.merchantbackoffice.bindProductFilterForm();
    KMVP.merchantbackoffice.bindSynchronizeButton();
    KMVP.merchantbackoffice.loadMerchantProducts($('.js-merchant-backoffice-products-filter-form'));
    KMVP.merchantbackoffice.bindMerchantValidateProductsButton();
    KMVP.merchantbackoffice.bindPaginationLink();
});